import { Box, Stack, Typography } from '@mui/material';
import { Panel } from '@/components/Panel';
import { TerminalImage } from '@/components/TerminalImage';
import contactPhoto from '@/assets/headshot.png';

export const ContactPanel = () => {
  return (
    <Panel sx={{ m: 2, maxWidth: '40rem', height: 'fit-content' }}>
      <Stack direction="row" spacing={3} alignItems="center">
        {/* Portrait */}
        <TerminalImage
          src={contactPhoto}
          alt="Developer portrait"
          width={120}
          height={160}
        />

        {/* Identity text */}
        <Box>
          <Typography
            variant="overline"
            sx={{ color: 'text.secondary', letterSpacing: '0.12em' }}
          >
            USER PROFILE
          </Typography>

          <Typography variant="h4" sx={{ color: 'primary.main', mb: 0.5 }}>
            Jovanni Mosca
          </Typography>

          <Typography
            variant="caption"
            sx={{
              display: 'block',
              color: 'secondary.main',
              mb: 2,
            }}
          >
            FULL-STACK SOFTWARE DEVELOPER
          </Typography>

          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Builds resilient frontend and backend systems with a focus on
            clarity, performance, and long-term maintainability. Enjoys working
            at the intersection of design, systems, and developer experience.
          </Typography>
        </Box>
      </Stack>
    </Panel>
  );
};
